var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInst(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#44d62c;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,3.06A12.94,12.94,0,1,0,28.94,16,12.95,12.95,0,0,0,16,3.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.13,9.26H11.87a2.6,2.6,0,0,0-2.6,2.61v8.26a2.6,2.6,0,0,0,2.6,2.61h8.26a2.61,2.61,0,0,0,2.61-2.61V11.87A2.61,2.61,0,0,0,20.13,9.26Zm.75,1.56h.3V13.1H18.9V10.82Zm-6.8,3.8a2.36,2.36,0,0,1,3.84,0A2.28,2.28,0,0,1,18.37,16a2.37,2.37,0,1,1-4.29-1.38Zm7.35,5.51a1.3,1.3,0,0,1-1.3,1.29H11.87a1.29,1.29,0,0,1-1.29-1.29V14.62h2A3.68,3.68,0,1,0,19.69,16a3.51,3.51,0,0,0-.28-1.38h2Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInst);
export default __webpack_public_path__ + "static/media/inst.fbfd248812615df77ea3ccdfdca75b54.svg";
export { ForwardRef as ReactComponent };